import styled from 'styled-components';
import { Typ21 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';
import { Ico16 } from 'dc/Ico';

export const GoalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fffde7;
`;

export const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Text = styled(Typ21)`
  margin-right: 8px;
`;

export const Label = styled(Lab010)`
  span {
    color: #263238;
  }
`;

export const EditButton = styled.button`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: -16px;
  border: none;
  background: none;
  cursor: pointer;
`;

export const Icon = styled(Ico16)`
  color: #455a64;
`;
